import { render, staticRenderFns } from "./Parsers.vue?vue&type=template&id=13e531bc&scoped=true"
import script from "./Parsers.vue?vue&type=script&lang=js"
export * from "./Parsers.vue?vue&type=script&lang=js"
import style0 from "./Parsers.vue?vue&type=style&index=0&id=13e531bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e531bc",
  null
  
)

export default component.exports